// @aide-title User detail
// @aide-description A single user's profile — their organisation, sign-in method and multi-factor status, plus the groups they belong to and the sites they can reach
// @aide-area Groups
// @aide-area Sites
import React from "react";
import { MaplesPage } from "components/pages";
import { UserDetails } from "features/Admin/UserDetails";
import * as BreadcrumbText from "constants/breadcrumbs";

const UserDetailsPage = ({ match }) => {
  const userId = match.params.id;
  return (
    <MaplesPage headerItems={[BreadcrumbText.Users]}>
      <UserDetails userId={userId} />
    </MaplesPage>
  );
};

export default UserDetailsPage;
